import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase
} from "../headers/light.js";
import { Content2Xl } from "components/misc/Layouts.js";
import logoImageSrc from "images/cblogo.png";
import serverIllustrationImageSrc from "images/server-illustration-2.svg";

const PrimaryBackgroundContainer = tw.div`-mx-8 px-8 bg-brand1 text-brand5`;
const Header = tw(HeaderBase)`max-w-none -mt-4 py-8 -mx-4 px-8`;
const NavLink = tw(NavLinkBase)`text-lg lg:text-xl font-bold border-0 lg:text-brand5 lg:hover:text-brand4 lg:hover:border-brand5 lg:focus:text-brand4`;
const LogoLink = tw(LogoLinkBase)`text-brand5 hocus:text-brand4`;

const TwoColPrimaryBkround  = ({
  heading = "Below The Line",
  description = "Nice little tag line",
  secondaryButtonText = "Request a Ticket",
  primaryButtonText = "Make a Donation",
  secondaryButtonUrl = "/request",
  primaryButtonUrl = "/donate",
  imageSrc = serverIllustrationImageSrc,
}) => {
  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      Clarebrand Village Hall
    </LogoLink>
  );
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/">Home</NavLink>
      <NavLink href="/#nav-our-values">Our Values</NavLink>
      <NavLink href="/book">Contact Us</NavLink>

    </NavLinks>
  ];
  return (
    <PrimaryBackgroundContainer>
      <Content2Xl>
        <Header logoLink={logoLink} links={navLinks} />
      </Content2Xl>
    </PrimaryBackgroundContainer>
  );
};

export default TwoColPrimaryBkround;
